export const initialValues = {
  category: '',
  section: '',
  brand: '',
  discount: '',
  highRating: false,

  minPrice: 0,
  maxPrice: 0,
  // This is for show clean filters validation
  defaultMinPrice: 0,
  defaultMaxPrice: 0,

  sort: ''
};

export const mapPropsToValues = () => initialValues;

export const RECOMMENDATIONS_FIELDS = ['category'];

export const FILTER_CATALOG_FIELDS = [
  'brand',
  'minPrice',
  'maxPrice',
  'discount',
  'section',
  'brand',
  'highRating',
  'sort',
];

export const FIELDS_TO_CLEAN = [
  ...RECOMMENDATIONS_FIELDS,
  ...FILTER_CATALOG_FIELDS
];
